
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import RegionTable from '../components/RegionTable';

const Region = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/region/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Region Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Region
        </button>
      </div>

      <RegionTable />
    </div>
  );
};

export default Region